module.exports = __webpack_public_path__ + "img/test1.38bbe31e.jpg";